module.exports = __webpack_public_path__ + "static/media/ph_g01.ff020e1c.jpg";